import { Plus, Pencil, Trash2 } from "lucide-react";

const OffersTab = ({ offers, onAdd, onEdit, onDelete, onToggleActive }) => (
  <div className="bg-white border border-[#E6E4DD]">
    <div className="p-6 border-b border-[#E6E4DD] flex justify-between items-center">
      <div><h2 className="font-medium text-[#1C1C1A]">Offers & Discounts</h2><p className="text-sm text-[#6B6A65] mt-1">Shown on the Collections page</p></div>
      <button onClick={onAdd} className="btn-primary text-xs py-2 px-4 flex items-center gap-1" data-testid="add-offer-btn">
        <Plus size={14} /> Add Offer
      </button>
    </div>
    <div className="overflow-x-auto">
      <table className="admin-table">
        <thead><tr><th>Offer</th><th>Discount</th><th>Valid Until</th><th>Status</th><th>Actions</th></tr></thead>
        <tbody>
          {offers.map(o => (
            <tr key={o.id} data-testid={`offer-row-${o.id}`}>
              <td><p className="font-medium">{o.title}</p><p className="text-xs text-[#6B6A65] line-clamp-1">{o.description}</p></td>
              <td><span className="px-3 py-1 text-xs font-semibold bg-[#4A5D4E]/10 text-[#4A5D4E]">{o.discount_text}</span></td>
              <td className="text-sm text-[#6B6A65]">{o.valid_until || "No expiry"}</td>
              <td>
                <button onClick={() => onToggleActive(o)} className={`px-2 py-1 text-xs ${o.is_active ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-500"}`} data-testid={`toggle-offer-${o.id}`}>
                  {o.is_active ? "Active" : "Inactive"}
                </button>
              </td>
              <td>
                <div className="flex items-center gap-2">
                  <button onClick={() => onEdit(o)} className="p-2 hover:bg-[#F7F5F0]" data-testid={`edit-offer-${o.id}`}><Pencil size={16} className="text-[#6B6A65]" /></button>
                  <button onClick={() => onDelete(o.id)} className="p-2 hover:bg-red-50" data-testid={`delete-offer-${o.id}`}><Trash2 size={16} className="text-red-500" /></button>
                </div>
              </td>
            </tr>
          ))}
          {offers.length === 0 && <tr><td colSpan={5} className="text-center py-12 text-[#6B6A65]">No offers yet.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>
);

export default OffersTab;
